<script setup>
import {ref} from "vue";
import { useRouter } from 'vue-router'
import SNBPolicy from "../../../../../layouts/nav/SNBPolicy.vue";

const router = useRouter()

const selectedOption = ref({ label: '', value: '' });

const personalList = [
  { label:"[현행]2025년 05월 29일", value: "personal20250529" },
  { label:"이전 변경 이력 없음", value: "" },
];

const onSelectPersonal = (option) => {
  if (option.value === '') {
    return; // 빈 값이면 조기 종료
  }

  selectedOption.value = option
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNBPolicy class="snb" />
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title">
              <h3>개인정보처리방침</h3>
            </div>
            <div class="content-title grid" style="justify-content: flex-end;">
              <KSASelect :options="personalList" class="select" @selectOption="onSelectPersonal" />
            </div>
              <!--v-if="selectedOption.value === 'personal20250529'"-->
            <div>
              개인정보 취급방침<br/>
              * 본 사이트는 이용하시는 모든 이용자들의 개인정보를 소중히 여깁니다.<br/><br/>

              개인정보 수집에 대한 동의<br/>
              한국디스플레이산업협회 (이하 "협력단"라 한다) 은 귀하께서 협력단 개인정보보호방침 또는 이용약관의 내용에 대해 「동의한다」버튼 또는 「동의하지 않는다」버튼을 클릭할 수 있는 절차를 마련하여, 「동의한다」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.<br/><br/>

              아동의 개인정보보호<br/>
              1. 회사는 만14세 미만 아동의 개인정보를 수집하는 경우 법정대리인의 동의를 받습니다.<br/>
              2. 만14세 미만 아동의 법정대리인은 아동의 개인정보의 열람, 정정, 동의철회를<br/>
              요청할 수 있으며, 이러한 요청이 있을 경우 회사는 지체없이 필요한 조치를 취합니다.<br/><br/>

              수집하는 개인정보의 항목<br/><br/>

              협력단은 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br/>
              1 수집항목 : 이름 , 생년월일 , 로그인ID(이메일) , 비밀번호 , 휴대전화번호 , 소속 기관 , 직책, 정부수행과제 , 수행역할 , 서비스 이용기록 , 접속 로그 , 쿠키 , 접속 IP 정보<br/>
              2 개인정보 수집방법 : 홈페이지(회원가입, 게시판 등)<br/><br/>

              개인정보의 수집 및 이용목적<br/><br/>

              회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br/>
              1. 서비스 제공<br/>
              고객서비스 이용에 관한 통지, CS대응을 위한 이용자 식별, 콘텐츠 이용 , 컨설팅 위탁 , 물품배송 또는 청구지 등 발송<br/>
              2. 회원 관리<br/>
              회원제 서비스 이용에 따른 본인확인 , 개인 식별 , 불량회원의 부정 이용 방지와 비인가 사용 방지 , 가입 의사 확인 , 연령확인 , 불만처리 등 민원처리 , 고지사항 전달<br/>
              3. 마케팅 및 광고에 활용<br/>
              이벤트 등 광고성 정보 전달 , 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계<br/>
              단, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.<br/>

              개인정보의 보유 및 이용기간<br/>
              1. 귀하의 개인정보는 다음과 같이 개인정보의 수집목적 또는 제공받은 목적이 달성되면 파기됩니다.<br/>
              - 회원가입정보의 경우, 회원가입을 탈퇴하거나 회원에서 제명된 때<br/>
              - 대금지급정보의 경우, 대금의 완제일 또는 채권소멸시효기간의 만료된 때<br/>
              - 배송정보의 경우, 물품 또는 서비스가 인도되거나 제공된 때 (단, 상법 등 법령의<br/>
              규정에 의하여 보존할 필요성이 있는 경우에는 예외로 합니다.)<br/>
              2. 위 보유기간에도 불구하고 계속 보유하여야 할 필요가 있을 경우에는 귀하의 동의를 받겠습니다.<br/><br/>

              개인정보의 파기 절차 및 방법<br/><br/>

              회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.<br/>
              1. 파기절차<br/>
              회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.<br/>
              2 파기방법<br/>
              - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br/><br/>

              개인정보 제공<br/>
              회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br/>
              - 이용자들이 사전에 동의한 경우<br/>
              - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우<br/><br/>

              수집한 개인정보의 위탁<br/><br/>

              회사는 서비스 향상을 위해서 귀하의 개인정보를 외부에 위탁하여 처리할 수 있습니다.<br/>
              1. 한국디스플레이산업협회는 이용자의 개인정보를 수집목적 및 이용목적을 초과하여 이용하거나 타인 또는 타기관에 제공하지 않습니다.<br/>
              2. 단, 법률에 특별한 규정이 있는 경우, 범죄의 수사, 법원의 재판업무수행을 위해<br/>
              필요한 경우 이용자의 동의가 있거나 이용자에게 제공하는 경우, 통계목적,학술연구등의 목적을 위한 경우로서 특정 개인을 식별할 수 없는 형태로 정보가 제공되는 경우등은 예외입니다.<br/><br/>

              이용자 및 법정대리인의 권리와 그 행사항법<br/>
              이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다. 이용자들의 개인정보 조회,수정을 위해서는 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을 가입해지(동의철회)를 위해서는 “회원탈퇴”를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.<br/>
              혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.<br/>
              귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다.<br/>
              회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 “회사가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.<br/><br/>

              개인정보에 관한 민원서비스<br/><br/>

              협력단은 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.<br/>
              개인정보관리책임자 성명 : 이지훈 [ 수정 예정 ]<br/>
              전화번호 : 02-3014-5713<br/>
              이메일 : leejh@kdia.org<br/>
              귀하께서는 협력단의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 협력단은 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.<br/><br/>

              기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.<br/><br/>

              1. 개인분쟁조정위원회 (www.1336.or.kr/1336)<br/>
              2. 정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)<br/>
              3. 대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr/02-3480-3600)<br/>
              4. 경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)<br/>

<!--              <KSATextButton-->
<!--                  text="[별첨] - 개인정보 처리방침 작성지침(2025.4.).pdf"-->
<!--                  @click="$download('/platformfile/public/policy/202504.pdf')"-->
<!--              />-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.lecture-wrap {
  .content-title {
    font-weight: normal;
    .select {
      min-width: 166px;
      width: fit-content;
    }
  }
  .lecture-list {
    &:first-of-type {
      margin-bottom: 40px;
    }
  }
}
</style>
